export default "__VITE_ASSET__KNmR4T7Z__"